import { render, staticRenderFns } from "./SecurityWidget.vue?vue&type=template&id=26967d7a&scoped=true"
import script from "./SecurityWidget.vue?vue&type=script&lang=js"
export * from "./SecurityWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26967d7a",
  null
  
)

export default component.exports